import Alpine from 'alpinejs'
import utils from './utils'
import labelForm from './labelForm'
import storePrintForm from './storePrintForm'
import preventUnsavedChanges from './preventUnsavedChanges'
import tinyMCESetup from './tinyMCESetup'
import serviceCalendar from './serviceCalendar'
import preventDoubleFormSubmissions from './preventDoubleFormSubmissions'

window.utils = utils
window.labelForm = labelForm
window.storePrintForm = storePrintForm
window.tinyMCESetup = tinyMCESetup
window.serviceCalendar = serviceCalendar
window.preventDoubleFormSubmissions = preventDoubleFormSubmissions

preventUnsavedChanges()

Alpine.start()